import React from 'react';

const SettingsPage: React.FC = () => {
  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-bold mb-6">Paramètres</h1>
      <div className="text-center text-gray-500">
        Fonctionnalité en développement
      </div>
    </div>
  );
};

export default SettingsPage;
